<div class="col-md-6">
  <label class="form-label">Empregador</label>
  <select
    class="form-select"
    name="empregadorFuncionario"
    [ngModel]="empregadorSelecionado"
    (ngModelChange)="selecionarEmpregador($event)"
    required>
    <option value="">Selecione</option>
    <option *ngFor="let item of empregadores" [value]="item.id">{{ item.razaoSocial }}</option>
  </select>
</div>
<div class="col-md-6">
  <label class="form-label">Nome</label>
  <input class="form-control" name="nome" [(ngModel)]="funcionario.nome" (ngModelChange)="emitirFuncionario()" required>
</div>
<div class="col-md-3">
  <label class="form-label">Matricula</label>
  <input class="form-control" name="matricula" [(ngModel)]="funcionario.matricula" (ngModelChange)="emitirFuncionario()" required>
</div>
<div class="col-md-3">
  <label class="form-label">CPF</label>
  <input
    class="form-control"
    name="cpf"
    [ngModel]="funcionario.cpf"
    (ngModelChange)="alterarCpf($event)"
    maxlength="14"
    inputmode="numeric"
    placeholder="000.000.000-00"
    required>
</div>
<div class="col-md-3">
  <label class="form-label">PIS/PASEP</label>
  <input class="form-control" name="pisPasep" [(ngModel)]="funcionario.pisPasep" (ngModelChange)="emitirFuncionario()">
</div>
<div class="col-md-3">
  <label class="form-label">Senha portal</label>
  <input
    class="form-control"
    type="password"
    name="senhaPortal"
    [(ngModel)]="funcionario.senhaPortal"
    (ngModelChange)="emitirFuncionario()"
    autocomplete="new-password"
    placeholder="Opcional"
    minlength="6">
  <div class="form-text">Vazio usa os 6 primeiros digitos do CPF. Nao e exibida depois de salva.</div>
</div>
<div class="col-md-3">
  <label class="form-label">Admissao</label>
  <input class="form-control" type="date" name="dataAdmissao" [(ngModel)]="funcionario.dataAdmissao" (ngModelChange)="emitirFuncionario()">
</div>
<div class="col-md-4">
  <label class="form-label">Cargo</label>
  <input class="form-control" name="cargo" [(ngModel)]="funcionario.cargo" (ngModelChange)="emitirFuncionario()">
</div>
<div class="col-md-4">
  <label class="form-label">Departamento</label>
  <select class="form-select" name="departamentoFuncionario" [ngModel]="funcionario.departamentoId" (ngModelChange)="alterarDepartamento($event)">
    <option value="">Sem departamento vinculado</option>
    <option *ngFor="let departamento of departamentos" [value]="departamento.id">{{ departamento.nome }}</option>
  </select>
</div>
<div class="col-md-3">
  <label class="form-label">Jornada de ponto</label>
  <select class="form-select" name="jornadaFuncionario" [(ngModel)]="funcionario.jornadaId" (ngModelChange)="emitirFuncionario()">
    <option value="">Padrao do empregador</option>
    <option *ngFor="let jornada of jornadas" [value]="jornada.id">
      {{ jornada.nome }}{{ jornada.padrao ? ' (padrao)' : '' }}
    </option>
  </select>
</div>
<div class="col-md-1 d-flex align-items-end">
  <div class="form-check">
    <input class="form-check-input" type="checkbox" name="ativoFuncionario" [(ngModel)]="funcionario.ativo" (ngModelChange)="emitirFuncionario()">
    <label class="form-check-label">Ativo</label>
  </div>
</div>
<div class="col-md-5">
  <label class="form-label" for="podeSolicitarOficio">Pode Solicitar Oficio/Portaria/Decreto ?</label>
  <select
    class="form-select"
    id="podeSolicitarOficio"
    name="podeSolicitarOficio"
    [(ngModel)]="funcionario.podeSolicitarOficio"
    (ngModelChange)="emitirFuncionario()">
    <option [ngValue]="false">Não</option>
    <option [ngValue]="true">Sim</option>
  </select>
</div>
